import axiosInstance from '../../../../services/axios/axios';

export const getUserInfo = async esoFiId => {
	try {
		const response = await axiosInstance.get(
			`api/UserAccessReview/GetUserInfo/${esoFiId}`
		);
		return response;
	} catch (ex) {
		console.error(
			'error occurred fetching user info for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex
		);
		return {
			data: [],
			error:
				'error occurred fetching user info for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex,
		};
	}
};
